import { APP_INITIALIZER, NgModule } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import { LayoutService } from './configuracao/shared/layout.service'
import { BureauService } from './core/services/bureau.service'
import { OperadorService } from './core/services/operador.service'
import { SchemaService } from './core/services/schema.service'
import { TelemetriaService } from './core/services/telemetria.service'
import { EstabelecimentoValidarService } from './estabelecimentos/shared/estabelecimento-validar.service'

@NgModule({
    providers: [
        SchemaService,
        OperadorService,
        BureauService,
        LayoutService,
        TelemetriaService,
        EstabelecimentoValidarService,
        {
            provide: APP_INITIALIZER,
            useFactory: init,
            multi: true,
            deps: [
                SchemaService,
                OperadorService,
                BureauService,
                LayoutService,
                TelemetriaService,
                EstabelecimentoValidarService,
            ],
        },
    ],
})
export class AppInitializerModule {}

export function init(
    schemaService: SchemaService,
    operadorService: OperadorService,
    bureauService: BureauService,
    layoutService: LayoutService
) {
    return () => {
        return schemaService
            .evolve()
            .toPromise()
            .then(() => {
                return Observable.forkJoin(
                    operadorService.obterCorrente(),
                    bureauService.obterCorrente(),
                    layoutService.obterLayoutEAplicar()
                ).toPromise()
            })
    }
}



// WEBPACK FOOTER //
// ./src/app/app-initializer.module.ts